export const dashboardZh = {
  "cost.commitment": "独立参考：合同月费承诺（不计入账单合计）",
  "cost.known_amount": "已取得正向金额",
  "cost.resource_id": "查看资源与原始计量字段",
  "cost.latest_period": "最新记录区间结束（区间可能未结束）",
  "cost.usd": "美元",
  "cost.partial_daily": "已核对部分金额",
  "cost.saving_unverified": "尚未评估清理节省金额",
  "cost.overview": "服务期费用总览",
  "cost.fixed": "固定订阅",
  "cost.variable": "按量费用",
  "cost.known_total": "本服务月费用",
  "cost.composition_note":
    "仅汇总所选月份开具的已核验账单，含税及抵扣；服务发生月份见原始明细。合同月费与用量均不重复加入。账单金额不等同于银行卡扣款。",
  "cost.partial_note":
    "这里只包含已取得的账单，不保证已覆盖全部支出。未出账、未导入、尚未核实的金额不填零、不进入饼图；正向费用占比不包含抵扣。",
  "cost.fixed_missing": "该月固定订阅记录尚未核实，不能按零元计算。",
  "cost.fixed_note":
    "固定月费不随每日请求量改变，也不会按天重复计费。Cloudflare 按 15 日起算的订阅账期扣费；这里展示月费承诺，实际扣款见历史账单。",
  "cost.verified": "核验日期",
  "cost.subscription_source": "供应商订阅页 / 已核验账单",
  "cost.breakdown": "按量费用花在哪里",
  "cost.trend": "每日按量消费",
  "cost.trend_note":
    "点击日期查看明细。Neon 仅提供实际用量，不推算每日金额；Cloudflare 日费用须与连续账期累计值核对一致，否则显示未核实。无数据不等于零支出。",
  "cost.details": "具体费用明细",
  "cost.history": "历史月份",
  "cost.date_select": "明细日期",
  "cost.current_month": "回到当月",
  "cost.current_day": "今天",
  "cost.monthly_detail": "整月明细",
  "cost.daily_detail": "当日明细",
  "cost.no_data": "无数据",
  "cost.monthly_only": "仅月度汇总",
  "cost.data_time": "用量数据同步时间",
  "cost.cache_time": "缓存下次可自动更新",
  "cost.sync_note":
    "时间均为 UTC。同步成功只代表已取回供应商数据，供应商自身可能延迟计量。手动更新最短间隔 60 秒。",
  "cost.never_synced": "尚未成功同步",
  "cost.archived": "历史归档数据",
  "cost.context_time": "订阅记录核验时间",
  "cost.scope_note":
    "默认当月总览、今天明细；历史月份选择最后一个有日记录的日期；仅有月汇总时显示整月明细。",
  "cost.category.compute": "计算",
  "cost.category.storage": "存储",
  "cost.category.requests": "请求与读写操作",
  "cost.category.network": "网络流量",
  "cost.category.other": "其他用量",
  "cost.service.workers_paid": "Workers 基础订阅",
  "cost.service.workers_platforms": "应用托管平台订阅",
  "cost.service.do_duration": "有状态服务计算时长",
  "cost.service.do_requests": "有状态服务请求",
  "cost.service.kv_writes": "键值存储写入",
  "cost.service.kv_reads": "键值存储读取",
  "cost.service.kv_list": "键值存储列举",
  "cost.service.kv_delete": "键值存储删除",
  "cost.service.r2_storage": "R2 对象存储",
  "cost.service.r2_a": "R2 写入与列举操作",
  "cost.service.r2_b": "R2 读取操作",
  "cost.service.do_sql": "有状态服务数据库存储",
  "cost.service.do_storage": "有状态服务存储",
  "cost.service.workers_requests": "Worker 请求",
  "cost.service.workers_cpu": "Worker 计算时间",
  "cost.unit.cu_hour": "计算单元·小时",
  "cost.unit.gb_month": "GB·月",
  "cost.unit.branch_hour": "分支·小时",
  "cost.unit.capacity_hour": "容量·小时",
  "cost.unit.million": "百万次",
  "cost.unit.bytes": "字节",
  "cost.unit.gb_seconds": "GB·秒",
  "cost.unit.count": "次",
  "cost.tax": "税费",
  "cost.credit": "抵扣 / 优惠",
  "cost.original": "供应商原始记录",
  "cost.invoice_source": "已核验供应商账单原件",
  "cost.conclusion": "费用结论与存储清理",
  "cost.storage_cost": "已取得存储费用",
  "cost.storage_snapshot": "当前存储核查快照",
  "cost.storage_history_note":
    "以下是独立标注日期的存储快照，不代表任意历史月份的存储状态。",
  "cost.storage_candidates": "测试账号有效存储记录候选",
  "cost.logical_size": "候选记录逻辑大小",
  "cost.metadata_objects": "存储元数据记录总数（含已删除）",
  "cost.storage_warning":
    "测试邮箱匹配只是候选依据；逻辑大小不等于实际可释放容量。清理前需核对对象引用、保留期限和恢复条件，本页不执行删除。",
  "cost.bucket_note": "R2 最近核查窗口的容量峰值，已包含全部桶；空桶不占图表。",
  "cost.bucket_uploads": "开发环境上传文件",
  "cost.bucket_packages": "开发环境应用包",
  "cost.bucket_source": "开发环境应用源码",
  "cost.bucket_exports": "开发环境导出文件",
  "cost.bucket_published": "开发环境发布内容",
  "cost.bucket_archive": "开发环境失败任务归档",
  "cost.bucket_other": "其他存储桶",
  "cost.objects": "对象",
  "cost.review_missing": "暂无存储快照",
  "cost.cleanup_review": "查看孤立对象核查",
  "cost.storage_users": "查看用户存储明细",
  "cost.storage_findings":
    "存储费用不会因对象数量多就必然很高。优先看实际容量、收费单价与免费额度；清理候选不等于全部可删除。",
  "cost.dominant": "主要费用分类",
  "cost.all_categories": "全部费用分类",
  "cost.section_usage": "按量费用明细",
  "cost.unknown_currency": "非美元 / 未定价项目不计入图表",
  "cost.zero_known": "已获取项目金额为零",
  "cost.no_slices": "没有可绘制的正向费用",
  "cost.adjustments": "负向调整单列，不绘入饼图",
  "cost.date_coverage": "本月有日明细的日期",
  "cost.history_note":
    "可查看近 12 个月。较早月份可能只有月度用量或账单；日明细超过供应商保留期后，仅显示已保存的历史归档。",
  "cost.data_partial": "部分数据",
  "cost.data_complete": "用量来源已连接",
  "cost.share": "占已知金额",
  "cost.per_month": "每月",
  "cost.not_paid": "累计用量 / 月费承诺，非付款总额",
};
export const dashboardEn: Record<keyof typeof dashboardZh, string> = {
  "cost.commitment":
    "Separate reference: monthly commitment (not added to invoices)",
  "cost.known_amount": "Retrieved positive amounts",
  "cost.resource_id": "Resource and raw metering fields",
  "cost.latest_period": "Latest interval end (interval may still be open)",
  "cost.usd": "USD",
  "cost.partial_daily": "Reconciled partial amount",
  "cost.saving_unverified": "Reclaimable bytes and monthly savings: unverified",
  "cost.overview": "Cost overview",
  "cost.fixed": "Fixed subscriptions",
  "cost.variable": "Usage costs",
  "cost.known_total": "Verified invoices issued this month",
  "cost.composition_note":
    "Verified invoices issued in the selected month only, including taxes and credits. Commitments and usage are not added. Invoices are not bank payments.",
  "cost.partial_note":
    "Coverage is incomplete. Unknown costs are excluded; shares refer only to known amounts.",
  "cost.fixed_missing":
    "Fixed subscriptions for this month are unverified, not zero.",
  "cost.fixed_note":
    "Monthly commitments do not change with daily requests or repeat each day. Cloudflare bills on its 15th-day cycle; see invoices for actual charges.",
  "cost.verified": "Verified at",
  "cost.subscription_source": "Provider subscriptions / verified invoices",
  "cost.breakdown": "Invoice breakdown",
  "cost.trend": "Daily usage trend",
  "cost.trend_note":
    "Select a date for details. Missing dates are not zero; monthly aggregates are never split into daily actuals.",
  "cost.details": "Cost line items",
  "cost.history": "Historical month",
  "cost.date_select": "Detail date",
  "cost.current_month": "Current month",
  "cost.current_day": "Today",
  "cost.monthly_detail": "Monthly details",
  "cost.daily_detail": "Daily details",
  "cost.no_data": "No data",
  "cost.monthly_only": "Monthly only",
  "cost.data_time": "Usage sync time",
  "cost.cache_time": "Next automatic cache refresh",
  "cost.sync_note":
    "All times are UTC. Successful retrieval does not remove provider metering delays. Manual refresh is limited to once per 60 seconds.",
  "cost.never_synced": "Never synchronized",
  "cost.archived": "Historical archive",
  "cost.context_time": "Subscription verification time",
  "cost.scope_note":
    "Defaults to this month and today; past months select the latest day with records.",
  "cost.category.compute": "Compute",
  "cost.category.storage": "Storage",
  "cost.category.requests": "Requests and operations",
  "cost.category.network": "Network transfer",
  "cost.category.other": "Other usage",
  "cost.service.workers_paid": "Workers Paid subscription",
  "cost.service.workers_platforms": "Workers for Platforms subscription",
  "cost.service.do_duration": "Durable Object compute duration",
  "cost.service.do_requests": "Durable Object requests",
  "cost.service.kv_writes": "KV writes",
  "cost.service.kv_reads": "KV reads",
  "cost.service.kv_list": "KV lists",
  "cost.service.kv_delete": "KV deletes",
  "cost.service.r2_storage": "R2 object storage",
  "cost.service.r2_a": "R2 class A operations",
  "cost.service.r2_b": "R2 class B operations",
  "cost.service.do_sql": "Durable Object SQL storage",
  "cost.service.do_storage": "Durable Object storage",
  "cost.service.workers_requests": "Worker requests",
  "cost.service.workers_cpu": "Worker CPU time",
  "cost.unit.cu_hour": "CU-hour",
  "cost.unit.gb_month": "GB-month",
  "cost.unit.branch_hour": "branch-hour",
  "cost.unit.capacity_hour": "capacity-hour",
  "cost.unit.million": "million",
  "cost.unit.bytes": "bytes",
  "cost.unit.gb_seconds": "GB-seconds",
  "cost.unit.count": "count",
  "cost.tax": "Tax",
  "cost.credit": "Credit / discount",
  "cost.original": "Original provider record",
  "cost.invoice_source": "Verified provider invoice",
  "cost.conclusion": "Cost findings and storage cleanup",
  "cost.storage_cost": "Retrieved storage costs this month",
  "cost.storage_snapshot": "Current storage review snapshot",
  "cost.storage_history_note":
    "This dated storage snapshot does not represent arbitrary historical storage states.",
  "cost.storage_candidates":
    "Confirmed storage records owned by test-account candidates",
  "cost.logical_size": "Candidate logical size",
  "cost.metadata_objects": "Total storage metadata records",
  "cost.storage_warning":
    "Test-email matches are candidates only. Logical size is not reclaimable physical storage. Check references, retention and recovery before deleting; this page does not delete data.",
  "cost.bucket_note":
    "R2 peak payload size in the reviewed window across all buckets; empty buckets are omitted.",
  "cost.bucket_uploads": "Development uploads",
  "cost.bucket_packages": "Development app packages",
  "cost.bucket_source": "Development app sources",
  "cost.bucket_exports": "Development exports",
  "cost.bucket_published": "Development published content",
  "cost.bucket_archive": "Development failed-job archive",
  "cost.bucket_other": "Other bucket",
  "cost.objects": "objects",
  "cost.review_missing":
    "No storage review snapshot is available for this month.",
  "cost.cleanup_review": "View orphan audit",
  "cost.storage_users": "View user storage",
  "cost.storage_findings":
    "Many objects do not necessarily mean high storage costs. Check bytes, rates and included allowances; candidates are not confirmed deletions.",
  "cost.dominant": "Largest known usage category",
  "cost.all_categories": "All cost categories",
  "cost.section_usage": "Usage details",
  "cost.unknown_currency":
    "Non-USD and unpriced items are excluded from charts",
  "cost.zero_known": "Retrieved items total zero",
  "cost.no_slices": "No positive costs to plot",
  "cost.adjustments":
    "Negative adjustments are listed separately, outside the pie",
  "cost.date_coverage": "Days with daily records",
  "cost.history_note":
    "Browse the last 12 months. Older months may contain monthly usage or invoices only; daily records beyond provider retention require an existing archive.",
  "cost.data_partial": "Partial data",
  "cost.data_complete": "Usage sources connected",
  "cost.share": "Share of known amount",
  "cost.per_month": "per month",
  "cost.not_paid": "Accrued usage / commitments, not payments",
};
